import { SVGProps } from 'react'

export const EyeOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="9"
    viewBox="0 0 13 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.71006 4.85659C1.64197 4.74877 1.60792 4.69486 1.58886 4.61171C1.57455 4.54925 1.57455 4.45075 1.58886 4.38829C1.60792 4.30514 1.64197 4.25123 1.71006 4.14341C2.27276 3.25242 3.9477 1 6.5002 1C9.0527 1 10.7276 3.25242 11.2903 4.14341C11.3584 4.25123 11.3925 4.30514 11.4115 4.38829C11.4259 4.45075 11.4259 4.54925 11.4115 4.61171C11.3925 4.69486 11.3584 4.74877 11.2903 4.85659C10.7276 5.74758 9.0527 8 6.5002 8C3.9477 8 2.27276 5.74758 1.71006 4.85659Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.5002 6C7.32863 6 8.0002 5.32843 8.0002 4.5C8.0002 3.67157 7.32863 3 6.5002 3C5.67177 3 5.0002 3.67157 5.0002 4.5C5.0002 5.32843 5.67177 6 6.5002 6Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
